import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { updateScan } from 'core/scan/store';
import { updateUserPreferences } from './updateUserPreferences';

export const fetchUserInformation = (): AppThunk => async (dispatch, _, context) => {
  const {
    userService,
    loggingService: logger,
    heatmapRecordingService,
    palmDetectionService,
  } = context;

  try {
    const user = await userService.getUserInformation();
    const scan = await palmDetectionService.getPalmistryScan();
    heatmapRecordingService.identify(user.email);

    dispatch(updateUserPreferences(user));

    if (scan) {
      dispatch(updateScan(scan));
    }
  } catch (e) {
    const err = normalizeError(e);
    logger.error(err);
    return null;
  }
};
